// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__RcPUg","sub":"styles_sub__jKgG1"};